/* //-----------------------------------------------------------------------
<copyright file="environment.ts" company="LGT India">
    Author:  Vanaraj
    Copyright (c) LGT India. All rights reserved.
</copyright>
----------------------------------------------------------------------- */
// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  postLogoutUrl: "https://prj-one-ui.icaniotech.com",
  baseurl: "https://prj-one-api.icaniotech.com/api",
  redirectionUrl: "https://prj-one-ui.icaniotech.com",
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
